import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';
import { useAppSelector } from 'src/store';
import { getCurrentProjectDefinitionFormState } from 'src/app/projects/views/new-project-definition/state/newProjectDefinitionSelector';
import { isBasicProject, hasInsightsFeature } from 'src/shared/utils/featureHelpers';
import commonStyles from 'src/app/projects/views/new-project-definition/NewProjectDefinition.module.scss';
import Checkbox from 'src/shared/components/checkbox/Checkbox';
import { useAppDispatch } from 'src/store';
import { setFormState } from 'src/app/projects/views/new-project-definition/state/newProjectDefinitionSlice';
import CompletionBadge from 'src/shared/components/completion-badge/CompletionBadge';
import ListOfErrors from 'src/shared/components/list-of-errors/ListOfErrors';
import SamplingEventsManager from './components/SamplingEventsManager';
import { getSectionErrors } from '../../helpers/sectionValidation';
import { getSectionStatus } from '../../helpers/sectionCompletion';

const SamplingCadence = () => {
    const dispatch = useAppDispatch();
    const formState = useAppSelector(getCurrentProjectDefinitionFormState);
    const { features, hasDefinedSampleEvents, samplingEvents } = formState;

    // Show for EDNA projects and Starter (no features) projects
    if (!hasInsightsFeature(features || []) && !isBasicProject(features || [])) {
        return null;
    }

    const handleCheckboxChange = (isChecked: boolean) => {
        const newFragment = {
            hasDefinedSampleEvents: isChecked,
            ...(!isChecked && { samplingEvents: [] }),
        };

        dispatch(setFormState(newFragment));
    };

    const shouldShowSamplingEventsSection =
        hasInsightsFeature(features || []) || hasDefinedSampleEvents || (samplingEvents && samplingEvents.length > 0);
    const errors = getSectionErrors(formState, 'samplingCadence');
    const status = getSectionStatus(formState, 'samplingCadence');

    return (
        <div className={commonStyles.formView}>
            <div className={commonStyles.formViewTitle}>
                <span>Sampling cadence</span>
                <div className={commonStyles.sectionStatus}>
                    {status.isComplete && <CheckCircle className={commonStyles.completeIcon} />}
                    {status.hasErrors && <AlertCircle className={commonStyles.errorIcon} />}
                    <CompletionBadge completedFields={status.completedFields} totalFields={status.totalFields} />
                </div>
            </div>
            <div className={commonStyles.formSection}>
                {isBasicProject(features || []) && (
                    <div className={commonStyles.formInputSection}>
                        <div className={commonStyles.formInputField}>
                            <div className={commonStyles.formInputSectionTitle}>Is the sampling event data known?</div>
                            <Checkbox label='Yes' onChange={handleCheckboxChange} checked={hasDefinedSampleEvents} />
                        </div>
                    </div>
                )}

                {shouldShowSamplingEventsSection && (
                    <div className={commonStyles.formInputSection}>
                        <SamplingEventsManager />
                    </div>
                )}

                <ListOfErrors errors={errors} className={commonStyles.formSection} />
            </div>
        </div>
    );
};

export default SamplingCadence;
